import { AuthActions } from 'store/modules/auth';
import { AxiosResponse } from 'axios';
import { CustomError } from 'core/errors';
import { UNAUTHORIZED } from 'http-status-codes';
import store from 'store';

export function errorHandlerInterceptor(error: any) {
  // Do something with response error
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    error.customError = mapResponseToCustomError(error.response);

    // logout user in case is unauthorized or refresh token failed
    if (
      error.response.status === UNAUTHORIZED ||
      (error.response.config.headers?.isTokenRefresh &&
        error.response.status >= 400)
    ) {
      store.dispatch(AuthActions.logout());
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    error.customError = CustomError.createClientError({
      code: 'CLIENT-REQUEST',
    });
  }

  return Promise.reject(error);
}

const mapResponseToCustomError = ({
  data,
  status,
  headers,
}: AxiosResponse<CustomError>): CustomError => {
  if (data?.description) {
    return CustomError.createClientError({
      ...data,
      statusCode: status,
      description: data.description.replace('- Forwarding error', ''),
      transactionId: headers?.transaccionid,
    });
  }

  return CustomError.createClientError({
    code: 'CLIENT-RESPONSE',
    statusCode: status,
    transactionId: headers?.transaccionid,
  });
};
